import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const madeToOrder = css`
  position: relative;
  display: flex;
  justify-content: left;
  gap: ${spacing.base}px;
  margin-top: ${spacing.xs}px;
  ${theme.responsiveText.BODY.XS}

  [data-testid='tooltip-container'] {
    position: static;
  }
`;

export const madeToOrderLabel = css`
  ${theme.responsiveText.BODY.XS}
  margin: 0;
`;

export const tooltipInfo = css`
  cursor: help;
  display: grid;
  grid-template-columns: 1fr ${spacing.md}px;
  place-items: center;
  ${responsiveText.BODY.XS};
`;

export const tooltipInfoIcon = css`
  display: block;
  height: ${spacing.md}px;
  width: ${spacing.md}px;
  margin: 0 0 0 ${spacing.base}px;
`;
